
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { CourseModule } from '../../store/modules/course'
import { UserModule } from '../../store/modules/user'
import { formatDate } from '../../utils/publish'
import HistorySign from '../../components/course/history-sign.vue'
import HistoryNoSign from '../../components/course/history-no-sign.vue'
import TableSign from '../../components/course/table-sign.vue'
import TableNoSign from '../../components/course/table-no-sign.vue'
  @Component({
    components: { HistorySign, HistoryNoSign, TableSign, TableNoSign}
  })
export default class AddList extends Vue {
    @Prop() student_info_id: string
    @Prop() is_show_student_info: boolean
    org_id: string = 'd06455545e6d4b929f4fbacbdc93dd24'
    studentId: any = ''
    studentCourseList:any = []
    campus_id: string = ''
    selectBaseCourse:string = ''
    campus: any = []
    employee: any = []
    employeeSelect: any = []
    detailEmployee: string = ''
    studentStatus: any = [
      {
        id: 7,
        value: '未签到'
      }, {
        id: 1,
        value: '签到'
      }, {
        id: 2,
        value: '取消预约'
      }, {
        id: 3,
        value: '学生旷课'
      }]
      
    selectStudentStatus: string = ''
    changeStudentLevelId: string = '' // 学员等级监听id
    changeStudentId: string = '' // 约课学员等级监听id
    changeBaseCourseId: string = '' // 课程种类监听
    changeTeacherId: any = [] // 上课老师监听
    changedetailTeacherId: string = '' // 上课老师监听
    changeStatusId: any = [] // 状态监听
    getOrderList: any = [] // 消费记录
    signType: number = 1
    selectThemeList:any = [] // 正式课签到已选择主题
    historyList: any = []
    itemId: string = '' // id

    createRemarkMsg: any = {
      remark_type: 2,
      desc: ''
    } // 新建备注
    dialogStkShop: boolean = false
    stkReason: any = {
      desc: ''
    }
    studentRemarks: string = ''
    teacherRemark: string = ''
    addCustomer: any = {} // 正式课签到
    materialSelectList: string = '' // 正式课签到选择素材list
    studentLevelId: string = '' // 正式课选择学员等级id
    historyListArr: any = []
    teacherEmployeeId: string = ''
    course_id: string = ''
    is_teach_plan: number = 1 // 教学计划
    dialogZskSign: boolean = false
    dialogZskNoSystem: boolean = false
    getStudentLevelList: any = []
    materialSelect: any = []
    selectStudentLevel: string = ''
    // 课程记录
    value: string = ''
    // 签到记录
    historySelectlist: any = []
    signHistoryList: any = []
    signPostData: any = []
    historySignInList: any = {}
    baseCourselist: any = []
    materialList: any = []
    selectLevel: string = ''
    selectThemeHistoryList: any = []
    // 公共筛选
    instrumentTypes = []
    // teacherType = []
    campusType = []
    time: any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time =  1
    end_time = Date.parse(this.time[1])/1000
    courseType: any = []
    courseTypeSelect: any = []
    from: any = ''
    course_type: string = ''  // 1 正式课 2 试听课
    is_formal: string = '' // 1 体系 2 非体系
    studentLevelList: any = []
    levelSelect: any = []
    outType: boolean = true
    courseClick: boolean = false
    addnotCustomer: any = {
      teacherRemark: '',
      subject_remark: '',
      materialSelect: [],
      studentRemarks: '',
      material_remark: ''

    } // 非体系课
    total_count: number = 0
    page: number = 1
    size: number = 10
    addOccupyTitle: string = ''
    is_sign_create: boolean = true
    courseName: string = ''
    studentItemData: any = {}
    sign_title: string = ''
    tableSignData: any = {}
    isNew: boolean = true

    mounted() {
      this.studentId = this.student_info_id
      this.getStudentDetail()
      this.getStudentLevel() //  课程等级
      this.getStudentCourse() //  课程记录
    }
    @Watch('is_show_student_info')
    getDetails(oldVal, newVal) {
      if(this.is_show_student_info) {
        this.studentId = this.student_info_id
        this.getStudentDetail()
        this.getStudentLevel() //  课程等级
        this.getStudentCourse() //  课程记录
      }
    }
    getTime(val, type) {
      return formatDate(val, type)
    }
    changeCourseName(val) {
      this.courseName = val
      this.getStudentCourse() //  课程记录
    }
    async getStudentDetail() {
      const res = await CourseModule.studentDetail({ 'student_id': this.studentId })
      this.campus_id = res.data.campus_id
      this.getSchool() // 上课老师
      this.getBaseCourse() // 课程种类

    }
    //  第一次签到既要回显又要展示历史签到数据
    async getSignLastList() {
      const res: any = await CourseModule.getCourseSignList({ 'student_id': this.studentId, 'course_id': this.course_id, 'types': 'last_sign', 'org_id': this.org_id })
      if (res.code === 200) {
        this.tableSignData = res.data
        this.signHistoryList = []
        this.signHistoryList.push(res.data)
        if (this.is_teach_plan == 1) { // 体系课签到
          this.dialogZskSign = true
        } else { // 非体系课签到
          this.dialogZskNoSystem = true
        }
      }
    }

    handleCurrentChange(val) {
      this.page = val
      this.getStudentCourse()
    }

    async getStudentCourse() {
      const res: any = await CourseModule.studentCourse({ 'course_name': this.courseName, 'student_id': this.studentId, 'sign_student_level_id': this.changeStudentId, 'student_level_id': this.changeStudentLevelId, 'course_type_id': this.changeBaseCourseId, 'teacher_id': this.changeTeacherId, 'sign_type': this.changeStatusId.toString(), 'instrument_type_id': '', 'campus_id': '', 'start_time': '', 'end_time': '', 'is_formal': '', 'ages': '', 'page': this.page, 'size': this.size, is_distinct_student: '', "packet_id": '' })
      this.studentCourseList = res.data.list
      this.total_count = res.data.total
    }

    getType(val) {
      this.is_teach_plan = val.is_teach_plan
      this.courseClick = true
      this.studentId = val.student_id
      this.itemId = val.id
      this.teacherEmployeeId = val.teacher_employee_id
      this.course_id = val.course_id
      this.getMaterial()
      this.getSignHistoryList(val)
    }


    signTypeClick(id,val) {
      if((id != 1 && val.sign_type === 1) || (id != 2 && val.sign_type === 2)) {
        return false
      }
      const start = formatDate(val.start_time, 3)
      const end = formatDate(val.end_time, 4)
      this.sign_title = start+'-'+end+'的课程进行签到'
      this.studentItemData = val
      this.is_teach_plan = val.is_teach_plan
      this.studentId = val.student_id
      this.itemId = val.id
      this.teacherEmployeeId = val.teacher_employee_id
      this.course_id = val.course_id

      if(id === val.sign_type) { // 编辑
        this.isNew = false
        if(id === 2) {
          this.signType = 2
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为取消预约？'
          this.dialogStkShop = true
          this.stkReason.desc = val.teacher_remark
        } else if (id === 3) {
          this.signType = 3
          this.dialogStkShop = true
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为学生旷课？'
          this.stkReason.desc = val.teacher_remark
        } else if (id === 1) {
          this.getType(val)
          this.is_sign_create = false
        }

      } else {  // 新建
        this.isNew = true
        if (id === 2) {
          this.signType = 2
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为取消预约？'
          this.dialogStkShop = true
        } else if (id == 3) {
          this.signType = 3
          this.addOccupyTitle = '是否将"'+ val.student_name +'"设为学生旷课？'
          this.dialogStkShop = true
        } else if (id == 1) {
          this.is_sign_create = true
          this.getMaterial()
          this.getSignLastList() //  签到记录
        }
      }
    }
    handleStkShopClose() {
      this.dialogStkShop = false
      this.dialogZskSign = false
      this.dialogZskNoSystem = false
      this.getStudentCourse()
    }

    // 试听课无意向到店原因提交
    handleStkShopTrue() {
      if (!this.stkReason.desc) {
        return false
      }
      let data:any = {
        teacher_remark: this.stkReason.desc,
        sign_type: this.signType,
        course_type: 1,
        id: this.itemId
      }
      this.signIn(data)
    }

    // 签到方法
    async signIn(data) {
      data.org_id = this.org_id
      const res: any = await UserModule.getClassSign(data)
      if (res.code == 200) {
        this.handleStkShopClose()
      }
    }

    // 正式课签到学员等级
    async getStudentLevel() {
      const res: any = await CourseModule.courseStudentLevel({ org_id: this.org_id })
      if (res.code === 200) {
        this.getStudentLevelList = res.data.list
      }
    }

    // 正式课签到取消
    handleZskSignClose() {
      this.dialogZskSign = false
      this.dialogZskNoSystem = false

      this.materialSelect = []
      this.studentRemarks = ''
      this.teacherRemark = ''
      this.selectStudentLevel = ''
    }

    handleNotZskSignTrue(val) {
      if(val.type) {
        val.data['id'] = this.itemId
        this.signIn(val.data)
        this.dialogZskNoSystem = false
      } else {
        this.dialogZskNoSystem = false
      }
    }
    // 正式课签到确定
    closeTableSign(val) {
      if(val.type) {
        val.data['id'] = this.studentItemData.id
        this.signIn(val.data)
      } else {
        this.dialogZskSign = false
      }
    }

    // 历史签到记录
    async getSignHistoryList(val) {
      const res: any = await UserModule.getCourseSignLists({ 'org_id': this.org_id, 'course_id': this.course_id, 'student_id': this.studentId, 'types': 'history_list' })
      if(res.code === 200) {
        this.tableSignData = res.data
        this.signHistoryList = []
        this.signHistoryList.push(res.data)
        if (val.is_teach_plan === 1) {
          // 体系课签到
          this.dialogZskSign = true
        } else {
          // 非体系课签到
          this.dialogZskNoSystem = true
        }
      }
    }

    // 获取素材列表
    async getMaterial() {
      const res: any = await CourseModule.getMaterial({ org_id: this.org_id, teacherEmployeeId: this.teacherEmployeeId, student_id: this.studentItemData.student_id })
      if (res.code === 200) {
        this.materialList = res.data.list
      }
    }

    // 课程种类
    async getBaseCourse() {
      const res: any = await CourseModule.baseCourse({ org_id: this.org_id, campus_id: this.campus_id })
      if (res.code === 200) {
        this.baseCourselist = res.data.list
      }
    }
    // 获取教师
    async getSchool() {
      const res: any = await CourseModule.getSchoolCampus({ types: 'campus', org_id: this.org_id })
      if (res.code === 200 && res.data.list) {
        this.campus = res.data.list
        if (this.campus.length > 0) {
          for (var i = 0; i < this.campus.length; i++) {
            if (this.campus[i].campus_id == this.campus_id) {
              this.employee = this.campus[i].values
            }
          }
        }
      }
    }
    // 学员等级监听
    changeStudentLevel(val) {
      this.changeStudentLevelId = val
      this.getStudentCourse()
    }
    // 约课学员学员等级监听
    changeStudent(val) {
      this.changeStudentId = val
      this.getStudentCourse()
    }
    // 课程种类监听
    changeBaseCourse(val) {
      this.changeBaseCourseId = val
      this.getStudentCourse()
    }
    // 上课老师监听
    changeTeacher(val) {
      this.changeTeacherId = val
      this.changeTeacherId = this.changeTeacherId.toString()
      this.getStudentCourse()
    }
    // 状态监听
    changeStatus(val) {
      this.changeStatusId = val
      this.getStudentCourse()
    }
    changeSelectMaterial(val) {
      let str:string = val.toString()
      this.materialSelectList = str
    }
}
